// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let NoteCollection
export default NoteCollection = (function () {
  NoteCollection = class NoteCollection extends (
    require("lib/static-shim").default(
      require("lib/core/paginated-collection").default
    )
  ) {
    static initClass() {
      this.prototype.model = require("./note").default
    }

    initialize(...args) {
      let array, val
      ;(array = args[0]),
        (val = args[1]),
        (this.options = val != null ? val : {})
      super.initialize(...arguments)
      ;({ context: this.context } = this.options)
      return (this.options.page_size = 300)
    }

    url() {
      if (this.paginateURL) {
        return this.paginateURL
      }
      const { page_size } = this.options
      let ncontext = this.options.context
      return this.urlRoot(
        `/api/private/note/?context=${ncontext}&page_size=${page_size}`
      )
    }

    getContext() {
      const ncontext = (() => {
        const result = []
        for (let op in this.options.context) {
          result.push(`${op}_${this.options.context[op]}`)
        }
        return result
      })()

      return ncontext.join(",")
    }
  }
  NoteCollection.initClass()
  return NoteCollection
})()

// Sorting precedence is curriculum > visibility > time
// comparator: (a, b)->
//   if (a.isCurriculum() is b.isCurriculum())
//     if a.get("visibility") is b.get("visibility")
//       if moment(a.get("created_time")).isAfter(b.get("created_time"))
//         -1
//       else
//         1
//     else if a.get("visibility") < b.get("visibility")
//       -1
//     else
//       1
//   else if a.isCurriculum()
//     -1
//   else
//     1
